module.exports = __webpack_public_path__ + "static/media/AliPayDesktopIcon.dbdae56d.svg";